import {
  PATH_NAME_BUSINESS,
  PATH_NAME_COMPANY,
  PATH_NAME_FINANCIAL_STATEMENTS,
  PATH_NAME_RECRUIT,
  PATH_NAME_PRIVACY_AGREEMENT
} from '@/common/resources/router.const'

export default [
  {
    path: '/customer/business',
    name: PATH_NAME_BUSINESS,
    alias: '/customer/business.html',
    components: {
      companyCustomer: () => import(/* webpackChunkName: "business" */'@/pages/customer/business')
    }
  },
  {
    path: '/customer/recruit',
    name: PATH_NAME_RECRUIT,
    alias: '/customer/recruit.html',
    components: {
      companyCustomer: () => import(/* webpackChunkName: "recruit" */'@/pages/customer/recruit')
    }
  },
  {
    path: '/customer/financial_statements',
    name: PATH_NAME_FINANCIAL_STATEMENTS,
    alias: '/customer/financial_statements.html',
    components: {
      companyCustomer: () => import(/* webpackChunkName: "recruit" */'@/pages/customer/financial_statements')
    }
  },
  {
    path: '/customer/company',
    name: PATH_NAME_COMPANY,
    alias: '/customer/company.html',
    components: {
      companyCustomer: () => import(/* webpackChunkName: "company" */'@/pages/customer/company')
    }
  },
  {
    path: '/customer/privacy_agreement',
    name: PATH_NAME_PRIVACY_AGREEMENT,
    alias: '/customer/privacy_agreement.html',
    components: {
      companyCustomer: () => import(/* webpackChunkName: "company" */'@/pages/customer/privacy_agreement')
    }
  }
]
